export class ClientEventBus {
    onEvents(events) {
        return Promise.all(events.map(event => this.onEvent(event)))
            .then(results => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    onEvent(event) {
        return this.controller
            ? this.controller.executeEvent(event)
            : Promise.reject(new Error('Controller not configured.'));
    }
    configureController(controller) {
        this.controller = controller;
    }
}
